import styled from "styled-components";
import { Card } from "../../components";

export const StyledCard = styled(Card)<{ isFinished?: boolean, isUpcoming?: boolean }>`
  min-width: 280px;
  max-width: 100%;
  margin: 0 0 24px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: baseline;
  position: relative;
  color: ${({ isFinished, theme }) => theme.colors[isFinished ? "textDisabled" : "secondary"]};
  color: ${({ isUpcoming, theme }) => theme.colors[isUpcoming ? "textDisabled" : "secondary"]};

  ${({ theme }) => theme.mediaQueries.sm} {
    max-width: 350px;
    margin: 0 12px 46px;
  }
`;
